import { useMemo } from 'react';

import {
  Listing,
  PropertyAdvertSortOptionID,
} from '@klokhuis/core/ApiClient/Klokhuis';

export const useSortedListings = (
  listings: Listing[] | undefined,
  sortOptionId: PropertyAdvertSortOptionID,
) => {
  return useMemo(() => {
    if (!listings || listings.length === 0) {
      return listings;
    }

    const sortedListings = [...listings];

    const topAdvertFirst = (a: Listing, b: Listing) =>
      (b.isTopAdvert ? 1 : 0) - (a.isTopAdvert ? 1 : 0);

    switch (sortOptionId) {
      case PropertyAdvertSortOptionID.NewestFirst:
        return sortedListings.sort(
          (a, b) => topAdvertFirst(a, b) || b.listingId - a.listingId,
        );

      case PropertyAdvertSortOptionID.PriceAscending:
        return sortedListings.sort((a, b) => {
          const priceA = a.salePrice || 0;
          const priceB = b.salePrice || 0;
          return topAdvertFirst(a, b) || priceA - priceB;
        });

      case PropertyAdvertSortOptionID.PriceDescending:
        return sortedListings.sort((a, b) => {
          const priceA = a.salePrice || 0;
          const priceB = b.salePrice || 0;
          return topAdvertFirst(a, b) || priceB - priceA;
        });

      default:
        return sortedListings.sort(topAdvertFirst);
    }
  }, [listings, sortOptionId]);
};
